import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { toast } from "sonner";

const FIELDS = [
    { key: "shippingPolicy", label: "Shipping Policy" },
    { key: "returnPolicy", label: "Return Policy" },
    { key: "termsConditions", label: "Terms & Conditions" },
];

export default function AdminPolicies() {
    const [p, setP] = useState(null);
    useEffect(() => { document.title = "Admin Policies | Loomara"; api.get("/policies").then(({ data }) => setP(data || {})); }, []);

    const save = async () => {
        try {
            const payload = {};
            FIELDS.forEach((f) => { payload[f.key] = p[f.key] || ""; });
            const { data } = await api.put("/policies", payload);
            setP(data);
            toast("Policies updated");
        } catch (e) { toast(e.response?.data?.detail || "Save failed"); }
    };

    if (!p) return <p>Loading…</p>;
    return (
        <div className="max-w-3xl" data-testid="admin-policies-page">
            <p className="eyebrow">Store Legal</p>
            <h1 className="font-serif text-4xl text-ink-900 mt-2 mb-8">Policies</h1>
            <div className="card-soft p-8 space-y-5">
                {FIELDS.map((f) => (
                    <div key={f.key}>
                        <label className="block text-[11px] uppercase tracking-[0.22em] text-ink-500 mb-1.5">{f.label}</label>
                        <textarea rows={5} value={p[f.key] || ""} onChange={(e) => setP({ ...p, [f.key]: e.target.value })} className="w-full bg-ivory-100 rounded-xl px-4 py-2.5 text-sm border border-sage-300/30 focus:outline-none focus:ring-2 focus:ring-sage-300" data-testid={`policy-${f.key}`} />
                    </div>
                ))}
                <div className="flex justify-end pt-2">
                    <button onClick={save} className="btn-primary" data-testid="policies-save">Save Policies</button>
                </div>
            </div>
        </div>
    );
}
